import { differenceInDays } from 'date-fns';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconClock } from '#src/atoms/icons/system/iconClock.ts';
import { iconInfoCircle } from '#src/atoms/icons/system/iconInfoCircle.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BrandXXS } from '#src/atoms/typography/index.tsx';
import { TimeLeft } from '#src/contexts/ticker/TimeLeft/index.tsx';
import type { Color } from '#src/style/types.ts';

type Props = {
  endDate: Date;
  totalDays?: boolean;
  defaultColor?: Color;
};

export const SetEndCountdownChip = ({
  endDate,
  totalDays = false,
  defaultColor = 'var(--c-nd-600)',
}: Props) => {
  const lessThan7Days = differenceInDays(endDate, new Date()) <= 7;
  const lessThan1Day = differenceInDays(endDate, new Date()) <= 1;

  let color: Color = defaultColor;
  if (lessThan7Days) {
    color = 'var(--c-yellow-400)';
  }
  if (lessThan1Day) {
    color = 'var(--c-red-400)';
  }

  return (
    <Horizontal gap={0.5}>
      <FontAwesomeIcon color={color} icon={iconClock} size="xs" />
      <BrandXXS>
        <TimeLeft
          time={endDate}
          options={totalDays ? { totalDays: true } : undefined}
        />
      </BrandXXS>
      {!!lessThan7Days && (
        <FontAwesomeIcon
          color="var(--c-nd-600)"
          icon={iconInfoCircle}
          size="xs"
        />
      )}
    </Horizontal>
  );
};
